// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyB8HNVEwumbyZ6WrjPAa49N0xZ792wEhPU",
    authDomain: "chat3test-59045.firebaseapp.com",
    projectId: "chat3test-59045",
    storageBucket: "chat3test-59045.firebasestorage.app",
    messagingSenderId: "950562883669",
    appId: "1:950562883669:web:d007fa2a551dd6f99f2cdc"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);